import React from 'react';
import clsx from 'clsx';

export default function QuantityButton({ onClick, className, children, ...props }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        className,
        'cp_quantity-button transition-all py-0.5 px-1 text-[var(--cp_text-secondary)] hover:brightness-75 focus:outline-none focus:ring-none',
      )}
      {...props}
    >
      {children}
    </button>
  );
}
